__turbopack_context__.v({
  "button": "styles-module-scss-module__YqC6MG__button",
  "buttons": "styles-module-scss-module__YqC6MG__buttons",
  "icon": "styles-module-scss-module__YqC6MG__icon",
  "item": "styles-module-scss-module__YqC6MG__item",
  "itemText": "styles-module-scss-module__YqC6MG__itemText",
  "link": "styles-module-scss-module__YqC6MG__link",
  "paragraph": "styles-module-scss-module__YqC6MG__paragraph",
  "root": "styles-module-scss-module__YqC6MG__root",
  "tooltip": "styles-module-scss-module__YqC6MG__tooltip",
});
